class truefitPushcart extends HTMLElement {
  constructor () {
    super()
    const cartData = JSON.parse(
      this.querySelector('#truefitCartDetails').textContent,
    )

    const interval = setInterval(() => {
      if (typeof tfcapi !== 'function') return
      clearInterval(interval)
      /* global tfcapi */
      tfcapi('sizeSampling', cartData)
    }, 200)
  }
}
customElements.define('truefit-pushcart', truefitPushcart)
